import { styled } from "styled-components";

export const BlogsSectionWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  overflow: hidden;
`;

export const BlogsSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  gap: 24px;
  padding: 64px 0;
`;
export const BlogsSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  margin: 0 auto;
  padding: 0 24px;
`;

export const BlogsSectionContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  padding-left: calc(
    max(24px, ((100vw - ${({ theme }) => theme.content.maxWidth}px) / 2)) + 24px
  );
`;

export const BlogsSectionContentContainer = styled.div`
  overflow: auto;
  scrollbar-width: none;
`;

export const BlogsSectionTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: ${({ theme }) => theme.colors.default[400]};
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
`;

export const BlogsSectionSubTitle = styled.div`
  color: #423f3d;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 32px */
  letter-spacing: 0.96px;
  text-transform: none;
  ${({ theme }) => theme.breakpoints.sm.query} {
    font-size: 24px;
  }
`;

export const BlogsSectionLinks = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: center;
  width: 200px;
  ${({ theme }) => theme.breakpoints.sm.query} {
    flex-direction: column;
    gap: 12px;
    justify-content: flex-start;
    align-items: flex-end;
    width: fit-content;
  }
`;
